<template>
  <div
    class="d-flex"
    :class="localClasses['container']"
    :style="styles['container']"
  >
    <v-pagination
      :color="color"
      v-model="localPage"
      :length="localTotalPage"
      :circle="circle"
    ></v-pagination>
  </div>
</template>

<script>
import emittable from '../../mixins/emittable'

import {
  VPagination
} from 'vuetify/lib'

const alignClassMapper = {
  'center': 'justify-center',
  'start': 'justify-start',
  'end': 'justify-end',
}

export default {
  name: 'Paginator',
  components: {
    VPagination
  },
  mixins: [emittable],
  data: function() {
    let lc = { ...this.classes };
    let classToAssign = alignClassMapper[this.justify]
    if(!lc['container']) {
      lc['container'] = {}
    }
    lc['container'][classToAssign] = true

    let ltp = this.totalPage
    if(!ltp) {
      ltp = this.value
    }

    return {
      localPage: this.value,
      localClasses: lc,
      localTotalPage: ltp
    }
  },
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    value: {
      type: Number,
      default: 1
    },
    totalPage: {
      type: Number,
      default: undefined
    },
    circle: {
      type: Boolean,
      default: false
    },
    justify: {
      type: String,
      default: 'center',
      validator: function (value) {
        return ['start', 'center', 'end'].indexOf(value) !== -1
      }
    },
    styles: {
      type: Object,
      default: function() {
        return {
          'paginator': {},
          'container': {}
        }
      }
    },
    classes: {
      type: Object,
      default: function() {
        return {
          'paginator': {},
          'container': {}
        }
      }
    }
  },
  watch: {
    localPage(newVal) {
      this.emit('input', newVal)
    },
    totalPage(newVal) {
      this.localTotalPage = newVal
    }
  }
}
</script>
